// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/mlinference/v1/ml_inference.proto" (package "viam.app.mlinference.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Annotations } from "../../data/v1/data";
import { FlatTensors } from "../../../service/mlmodel/v1/mlmodel";
import { BinaryID } from "../../data/v1/data";
/**
 * @generated from protobuf message viam.app.mlinference.v1.GetInferenceRequest
 */
export interface GetInferenceRequest {
    /**
     * The model framework and model type are inferred from the ML model registry item;
     * For valid model types (classification, detections) we will return the formatted
     * labels or annotations from the associated inference outputs.
     *
     * @generated from protobuf field: string registry_item_id = 1;
     */
    registryItemId: string;
    /**
     * @generated from protobuf field: string registry_item_version = 2;
     */
    registryItemVersion: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.BinaryID binary_id = 3;
     */
    binaryId?: BinaryID;
    /**
     * @generated from protobuf field: string binary_data_id = 5;
     */
    binaryDataId: string;
    /**
     * @generated from protobuf field: string organization_id = 4;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.mlinference.v1.GetInferenceResponse
 */
export interface GetInferenceResponse {
    /**
     * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensors output_tensors = 1;
     */
    outputTensors?: FlatTensors;
    /**
     * @generated from protobuf field: viam.app.data.v1.Annotations annotations = 2;
     */
    annotations?: Annotations;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetInferenceRequest$Type extends MessageType<GetInferenceRequest> {
    constructor() {
        super("viam.app.mlinference.v1.GetInferenceRequest", [
            { no: 1, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registry_item_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "binary_id", kind: "message", T: () => BinaryID },
            { no: 5, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mlinference.v1.GetInferenceRequest
 */
export const GetInferenceRequest = new GetInferenceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInferenceResponse$Type extends MessageType<GetInferenceResponse> {
    constructor() {
        super("viam.app.mlinference.v1.GetInferenceResponse", [
            { no: 1, name: "output_tensors", kind: "message", T: () => FlatTensors },
            { no: 2, name: "annotations", kind: "message", T: () => Annotations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mlinference.v1.GetInferenceResponse
 */
export const GetInferenceResponse = new GetInferenceResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.app.mlinference.v1.MLInferenceService
 */
export const MLInferenceService = new ServiceType("viam.app.mlinference.v1.MLInferenceService", [
    { name: "GetInference", options: {}, I: GetInferenceRequest, O: GetInferenceResponse }
]);
